import {
  ITraTienSinhVienDotFilterRequest,
  ITraTienSinhVienDotSaveRequest,
  ITraTienSinhVienExportRequest,
  ITraTienSinhVienKhoaRequest,
  ITraTienSinhVienSaveRequest,
  ITraTienSinhVienThietLapInRequest,
} from "../../../model/request/bao-cao/ITraTienSinhVienRequest";
import {
  ITraTienSinhVienChiTiet,
  ITraTienSinhVienDot,
  ITraTienSinhVienLog,
} from "../../../model/respone/bao-cao/ITraTienSinhVien";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eTraTienSinhVienActionsObj = {
  CHANGE_REQUEST: {} as Partial<ITraTienSinhVienDotFilterRequest>,

  // ===== Đợt =====
  LOAD_DOT_START: {} as ITraTienSinhVienDotFilterRequest,
  LOAD_DOT_SUCCESS: [] as ITraTienSinhVienDot[],
  LOAD_DOT_ERROR: "",
  /** Chọn đợt ở cột trái (0 = bỏ chọn). */
  CHON_DOT: 0,

  SAVE_DOT_START: {} as ITraTienSinhVienDotSaveRequest,
  SAVE_DOT_SUCCESS: 0,
  SAVE_DOT_ERROR: "",

  DELETE_DOT_START: 0,
  DELETE_DOT_SUCCESS: "",
  DELETE_DOT_ERROR: "",

  KHOA_START: {} as ITraTienSinhVienKhoaRequest,
  KHOA_SUCCESS: "",
  KHOA_ERROR: "",

  LUU_THIET_LAP_IN_START: {} as ITraTienSinhVienThietLapInRequest,
  LUU_THIET_LAP_IN_SUCCESS: "",
  LUU_THIET_LAP_IN_ERROR: "",

  // ===== Danh sách dòng =====
  LOAD_CHI_TIET_START: 0,
  LOAD_CHI_TIET_SUCCESS: [] as ITraTienSinhVienChiTiet[],
  LOAD_CHI_TIET_ERROR: "",

  SAVE_CHI_TIET_START: {} as ITraTienSinhVienSaveRequest,
  SAVE_CHI_TIET_SUCCESS: 0,
  SAVE_CHI_TIET_ERROR: "",

  // ===== Lịch sử =====
  LOAD_LOG_START: 0,
  LOAD_LOG_SUCCESS: [] as ITraTienSinhVienLog[],
  LOAD_LOG_ERROR: "",

  // ===== Xuất / in =====
  EXPORT_EXCEL_START: {} as ITraTienSinhVienExportRequest,
  EXPORT_EXCEL_SUCCESS: "",
  EXPORT_EXCEL_ERROR: "",

  XEM_TRUOC_START: {} as ITraTienSinhVienExportRequest,
  XEM_TRUOC_SUCCESS: "",
  XEM_TRUOC_ERROR: "",
  DONG_XEM_TRUOC: undefined,
};

export const eTraTienSinhVienActionIds = generateActionTypeIds(
  eTraTienSinhVienActionsObj,
  "TRA_TIEN_SINH_VIEN",
);

export type ITraTienSinhVienActionTypes = IGenericActionType<
  typeof eTraTienSinhVienActionsObj,
  "TRA_TIEN_SINH_VIEN"
>;
